import { useEffect } from "react"

import { useDebounce } from "./useDebounce"

export function useResizeListener({ onResize, skip, debounceTimeout = 400 }) {
  const _resizeListener = () => {
    onResize()
  }
  const resizeListener = useDebounce(debounceTimeout, _resizeListener)
  useEffect(() => {
    if (skip) {
      window.removeEventListener("resize", resizeListener)
      return
    }
    window.addEventListener("resize", resizeListener)
    return () => {
      window.removeEventListener("resize", resizeListener)
    }
  }, [skip, resizeListener])
}
